<template>
  <div class="container1">
    <page-header></page-header>
    <payment-result></payment-result>
    <!-- PaymentSuccess  -->
    <footer-page></footer-page>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader.vue'
import PaymentResult from './components/PaymentResult.vue'
import FooterPage from '@/components/FooterPage.vue'
export default {
  name: 'PaymentSuccess',
  components: {
    PageHeader,
    PaymentResult,
    FooterPage,
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {},
}
</script>

<style lang="scss" scoped></style>
